import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

let scrollRestorationConfigured = false;

function ensureManualScrollRestoration(): void {
  if (scrollRestorationConfigured || typeof window === 'undefined') {
    return;
  }
  scrollRestorationConfigured = true;
  try {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  } catch {
    // Ignore — some embedded browsers throw on history.scrollRestoration.
  }
}

/**
 * BrowserRouter does not restore scroll. Reset to top on pathname changes so
 * client navigations (e.g. homepage CTA → /alerts) do not land mid-page.
 * Hash targets scroll into view when present.
 */
export default function ScrollToTopOnNavigate(): null {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    ensureManualScrollRestoration();

    if (hash) {
      const id = decodeURIComponent(hash.replace(/^#/, ''));
      if (id) {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView();
          return;
        }
      }
    }

    window.scrollTo(0, 0);
    // Belt-and-suspenders for engines that keep body as the scrolling element.
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
  }, [pathname, hash]);

  return null;
}
